/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from "@";
import type { CustomerCampaign } from "../types";

interface UseHasCustomerSuggestedCampaignReturn {
  setFromFields: () => void;
}

export const useHasCustomerSuggestedCampaign = (
  _getValues: any,
  setValue: any,
  customerCampaign: CustomerCampaign | null,
): UseHasCustomerSuggestedCampaignReturn => {
  const setFromFields = useCallback(() => {
    setValue("allRequiredAmount", customerCampaign?.requiredAmount);
    setValue("name", customerCampaign?.projectTitle);
    setValue("title", customerCampaign?.projectTitle);
    setValue("classificationIds", [customerCampaign?.classificationId]);
    setValue("currentPaidAmount", 0);
    setValue("hideProjectFromStore", true);
  }, [
    setValue,
    customerCampaign?.requiredAmount,
    customerCampaign?.projectTitle,
    customerCampaign?.classificationId,
  ]);

  return {
    setFromFields,
  };
};
